module.exports = __webpack_public_path__ + "img/Skirt-Back-B3-Da-Gb-Ha-Ia.9a8a61bb.png";